import { TASK_CATEGORIES, TASK_STATUS_ENUM } from "globals/constants/task";
import { tasks as actionTypes } from "store/constants";
import { reduceSetSort, reduceSetPaging } from "store/factories/feed";
import { fetchableInitialState, reduceIsFetching } from "store/factories/fetchable";
import { baseInitialState } from "store/factories/initialState";

import { STORAGE_PROJECT_TASKS_TABLE_SORTING } from "../../globals/constants";

export const getStoredProjectTaskTableSorting = () => {
	const storedFormStatuses = JSON.parse(localStorage.getItem(STORAGE_PROJECT_TASKS_TABLE_SORTING));

	if (storedFormStatuses && storedFormStatuses.expires >= new Date().getTime()) {
		return storedFormStatuses;
	} else {
		localStorage.removeItem(STORAGE_PROJECT_TASKS_TABLE_SORTING);
	}

	return { column: "dueDate", direction: "ascending" };
};

const initialState = {
	...fetchableInitialState,
	award: {
		...fetchableInitialState,
		items: [],
	},
	proposal: {
		...fetchableInitialState,
		items: [],
	},
	content: {
		...baseInitialState.content,
		...fetchableInitialState,
		sort: getStoredProjectTaskTableSorting(),
		filters: {
			status: [ TASK_STATUS_ENUM.OPEN, TASK_STATUS_ENUM.IN_PROGRESS, TASK_STATUS_ENUM.ON_HOLD ],
			type: [ TASK_CATEGORIES.CAYUSE_SP_AD_HOC, TASK_CATEGORIES.CAYUSE_SP_MILESTONE ],
		},
		submissionInfo: {
			submissionAPI: "",
			submissionId: null,
		},
		parentInfo: {},
	},
};

export const reduceSetFilters = (state, { filters }) => ({
	...state,
	content: {
		...state.content,
		filters: {
			...state.content.filters,
			...filters,
		},
	},
});

export function taskList (state = initialState, action) {
	switch (action.type) {
	case actionTypes.AWARD_TASKS_IS_FETCHING:
		return {
			...state,
			award: reduceIsFetching(state.award, action),
		};
	case actionTypes.AWARD_TASKS_SET_ERROR:
		return {
			...state,
			award: {
				...state.award,
				error: action.payload,
			},
		};
	case actionTypes.AWARD_TASKS_SET_DATA:
		return {
			...state,
			award: {
				...state.award,
				items: action.payload,
			},
		};

	case actionTypes.PROPOSAL_TASKS_IS_FETCHING:
		return {
			...state,
			proposal: reduceIsFetching(state.proposal, action),
		};
	case actionTypes.PROPOSAL_TASKS_SET_ERROR:
		return {
			...state,
			proposal: {
				...state.proposal,
				error: action.payload,
			},
		};
	case actionTypes.PROPOSAL_TASKS_SET_DATA:
		return {
			...state,
			proposal: {
				...state.proposal,
				items: action.payload,
			},
		};

	case actionTypes.ALL_TASKS_IS_FETCHING:
		return {
			...state,
			content: reduceIsFetching(state.content, action),
		};
	case actionTypes.ALL_TASKS_SET_ERROR:
		return {
			...state,
			content: {
				...state.content,
				error: action.payload,
			},
		};
	case actionTypes.ALL_TASKS_SET_DATA:
		return {
			...state,
			content: {
				...state.content,
				...action.payload,
			},
		};

	case actionTypes.SET_SORT:
		return reduceSetSort(state, action);
	case actionTypes.SET_PAGING:
		return reduceSetPaging(state, action);
	case actionTypes.RESET:
		return initialState;
	case actionTypes.SET_FILTERS:
		return reduceSetFilters(state, action);
	default:
		return state;
	}
}


